import type { PageResponse } from '../types/api';
import type {
  CreateTaxCaseRequest,
  TaxCaseResponse,
  TransitionRequest,
  UpdateCurrencyRequest,
  UpdateEstimatedRefundRequest,
} from '../types/taxCase';
import { api } from './api';

export async function createTaxCase(
  body: CreateTaxCaseRequest,
): Promise<TaxCaseResponse> {
  const { data } = await api.post<TaxCaseResponse>('/tax-cases', body);
  return data;
}

export async function getTaxCase(id: string): Promise<TaxCaseResponse> {
  const { data } = await api.get<TaxCaseResponse>(`/tax-cases/${id}`);
  return data;
}

export async function getTaxCasesByClient(
  clientId: string,
  page = 0,
  size = 20,
): Promise<PageResponse<TaxCaseResponse>> {
  const { data } = await api.get<PageResponse<TaxCaseResponse>>(
    `/tax-cases/client/${clientId}`,
    { params: { page, size } },
  );
  return data;
}

export async function transitionTaxCaseStatus(
  id: string,
  body: TransitionRequest,
): Promise<TaxCaseResponse> {
  const { data } = await api.patch<TaxCaseResponse>(
    `/tax-cases/${id}/status`,
    body,
  );
  return data;
}

export async function updateEstimatedRefund(
  id: string,
  body: UpdateEstimatedRefundRequest,
): Promise<TaxCaseResponse> {
  const { data } = await api.patch<TaxCaseResponse>(
    `/tax-cases/${id}/estimated-refund`,
    body,
  );
  return data;
}

export async function updateCurrency(
  id: string,
  body: UpdateCurrencyRequest,
): Promise<TaxCaseResponse> {
  const { data } = await api.patch<TaxCaseResponse>(
    `/tax-cases/${id}/currency`,
    body,
  );
  return data;
}
